import {
  Component, Renderer2, ElementRef,
  Input, ChangeDetectorRef, ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { BrandService } from 'shared/brand/brand.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { SearchModel } from 'shared/search/search.model';
import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';
import { PART_ATTRIBUTES_FILTER_TYPE } from 'shared/search/active-filters/active-filter-types';
import { partAttributesStub } from 'shared/product/product-advanced-search/product-advanced-search.stub';
import { validationErrorStub } from 'shared/product/product-advanced-search/product-advanced-search.stub';

import { DashboardSearchService } from './dashboard-search.service';
import { DashboardSearchComponent } from './base/dashboard-search.component';


@Component({
  moduleId: module.id,
  selector: 'dashboard-search-pies-errors',
  templateUrl: './base/dashboard-search.component.html',
  styleUrls: ['./base/dashboard-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSearchPiesErrorsComponent extends DashboardSearchComponent {

  name: string = '';
  text: string = '';
  count: number = 0;
  filterName: string = 'validationError';
  filterValue: any;

  invalid: boolean = false;

  @Input() route: string = 'working';

  constructor(
    protected brandService: BrandService,
    protected permissionsService: PermissionsService,
    protected searchService: DashboardSearchService,
    protected router: Router,
    protected _renderer: Renderer2,
    protected ref: ChangeDetectorRef,
    public elementRef: ElementRef,
  ) {
    super(
      brandService,
      permissionsService,
      searchService,
      router,
      _renderer,
      ref,
      elementRef,
    );
  }

  get link(): string {
    return `/my-products/${this.route}`;
  }

  // protected
  protected initSearchModel() {
    this.searchModel = new SearchModel();
    this.searchModel.route = this.route;
    this.searchModel.statusModel = null;
    this.searchModel.filters.push(new ActiveFilterModel(
      this.filterName,
      null,
      PART_ATTRIBUTES_FILTER_TYPE,
      _.assign({
          attribute: _.assign({option: this.filterName}, partAttributesStub[this.filterName]),
          attributeName: partAttributesStub[this.filterName].attribute_name,
          attributeType: PART_ATTRIBUTES_FILTER_TYPE,
          attributeOption: this.filterName,
          selectValue: this.filterValue.option,
          selectData: validationErrorStub,
        },
        partAttributesStub[this.filterName],
      ),
    ));
    this.searchModel.itemsPerPage = 1;
  }

  protected setData(data: any) {
    this.count = _.get(data, 'total', '--');
    this.invalid = !!data.total;
  }

}
